import {
  toDataSourceRequestString,
  translateDataSourceResultGroups,
} from "@progress/kendo-data-query";
import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";
import {
  defaultAlertMessages,
  getConfirmErrorMessage,
  getConfirmSuccessMessage,
} from "../../utils/common";
import { confirmAlert } from "react-confirm-alert";
import i18n from "i18next";

class DavetliKatilimciService {
  getList(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/DavetliKatilimci/get-list-by-filter?${toDataSourceRequestString(
          dataState,
        )}`,
      )
      .then((response) => {
        return dataState.group && dataState.group.length
          ? translateDataSourceResultGroups(response.data)
          : { data: response.data, dataState };
      });
  }

  getForExcel(dataState) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/DavetliKatilimci/get-list-for-excel?${toDataSourceRequestString(
          dataState,
        )}`,
      )
      .then((response) => response.data);
  }

  add(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/DavetliKatilimci/add`, data)
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess =
          response.data?.message ?? response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        const messageKey = err.response?.data?.message;
        defaultAlertMessages.MessageDetailError = messageKey
          ? i18n.t(messageKey)
          : JSON.stringify(err.response?.data);
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  manualCheckIn(data) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/DavetliKatilimci/manual-check-in`, data)
      .then((response) => response.data?.data ?? response.data)
      .catch((err) => {
        const messageKey = err.response?.data?.message;
        defaultAlertMessages.MessageDetailError = messageKey
          ? i18n.t(messageKey)
          : JSON.stringify(err.response?.data);
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  delete(id) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/DavetliKatilimci/delete/${id}`)
      .then((response) => {
        defaultAlertMessages.MessageDetailSuccess =
          response.data?.message ?? response.message;
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        const messageKey = err.response?.data?.message;
        defaultAlertMessages.MessageDetailError = messageKey
          ? i18n.t(messageKey)
          : JSON.stringify(err.response?.data);
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  getPendingNotificationSummary(eventId) {
    return axios
      .get(
        `${
          API_GATEWAY + PR_DEP
        }/DavetliKatilimci/get-pending-notification-summary/${eventId}`,
      )
      .then((response) => response.data?.data ?? response.data);
  }

  sendNotification(payload) {
    return axios
      .post(
        `${API_GATEWAY + PR_DEP}/DavetliKatilimci/send-notification`,
        payload,
      )
      .then((response) => {
        const messageKey = response.data?.message ?? "notification_sent";
        defaultAlertMessages.MessageDetailSuccess = i18n.t(messageKey);
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmSuccessMessage(onClose, defaultAlertMessages);
          },
        });
        return response;
      })
      .catch((err) => {
        const body = err.response?.data;
        const messageKey = body?.message ?? "notification_all_failed";
        defaultAlertMessages.MessageDetailError = i18n.t(messageKey);
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  scanQr(payload) {
    return axios
      .post(`${API_GATEWAY + PR_DEP}/DavetliKatilimci/scan-qr`, payload)
      .then((response) => response.data?.data ?? response.data)
      .catch((err) => {
        const messageKey = err.response?.data?.message;
        defaultAlertMessages.MessageDetailError = messageKey
          ? i18n.t(messageKey)
          : JSON.stringify(err.response?.data);
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }

  getTicket(token) {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/DavetliKatilimci/get-ticket/${token}`)
      .then((response) => response.data?.data ?? response.data);
  }

  getQrLogs(id) {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/DavetliKatilimci/get-qr-logs/${id}`)
      .then((response) => response.data?.data ?? response.data)
      .catch((err) => {
        defaultAlertMessages.MessageDetailError = JSON.stringify(
          err.response?.data,
        );
        confirmAlert({
          customUI: ({ onClose }) => {
            return getConfirmErrorMessage(onClose, defaultAlertMessages);
          },
        });
        return Promise.reject(err);
      });
  }
}

export default new DavetliKatilimciService();
